import { Controller } from "@hotwired/stimulus";
import anime from "animejs";

export default class extends Controller {
    connect() {
        const [first, second] = this.element.querySelectorAll('line')

        this.enterHandler = () => {
            anime.set(second, {
                x1: 15
            })
        }

        this.leaveHandler = () => {
            anime.set(second, {
                x1: 0
            })
        }

        this.element.addEventListener('mouseenter', this.enterHandler)
        this.element.addEventListener('mouseleave', this.leaveHandler)
    }

    disconnect() {
        this.element.removeEventListener('mouseenter', this.enterHandler)
        this.element.removeEventListener('mouseleave', this.leaveHandler)
    }
}
